module.exports = __webpack_public_path__ + "static/media/Profile 4.b5573ced.svg";